export default "__VITE_ASSET__3ac0baa7__"